<template>
  <div class="vanta-bg" ref="vantaContainer"></div>
  <div class="register-container">
    <div class="register-box">
      <h1 class="title-gradient">Meeting Engine <span class="beta">(Beta)</span></h1>
      <div class="register-form">
        <label for="nombre">Nombre</label>
        <input v-model="nombre" type="text" id="nombre" class="input-field" placeholder="Nombre" />

        <label for="apellido">Apellido</label>
        <input v-model="apellido" type="text" id="apellido" class="input-field" placeholder="Apellido" />

        <label for="email">Correo Usach</label>
        <input v-model="email" type="text" id="email" class="input-field" placeholder="example@usach.cl" />

        <label for="password">Contraseña</label>
        <input v-model="password" type="password" id="password" class="input-field" placeholder="********" />

        <label for="repeatPassword">Repetir Contraseña</label>
        <input v-model="repeatPassword" type="password" id="repeatPassword" class="input-field" placeholder="********" />

        <div class="checkbox-group">
          <input v-model="termsAccepted" type="checkbox" id="terms" />
          <label for="terms">Acepto los términos y condiciones</label>
        </div>

        <button @click="register" class="register-button">Registrarse</button>
        <button @click="goToLogin" class="back-button">Volver</button>
      </div>
    </div>
    <v-btn @click="userExists(email)">test</v-btn>

    <v-snackbar v-model="snackbar" :timeout="snackbarTimeout" :color="snackbarColor">
      {{ snackbarText }}
    </v-snackbar>
  </div>
</template>

<script>
import api from '@/api.js';
import axios from 'axios';
import * as THREE from "three";
import FOG from "vanta/src/vanta.fog";

//TODO: TERMINAR ESTO
export default {
  name: "RegisterView",
  data() {
    return {
      email: "",
      password: "",
      repeatPassword: "",
      nombre: "",
      apellido: "",
      termsAccepted: false,
      snackbar: false,
      snackbarText: "",
      snackbarColor: "",
      snackbarTimeout: 3000,
      project: {},
    };
  },
  methods: {
    checkEmail() {
      return this.email.includes("@usach.cl");
    },
    verifyPassword() {
      return this.password === this.repeatPassword;
    },
    validateInputs(){
      if (!this.email || !this.password || !this.nombre || !this.apellido) {
        this.showSnackbar("Por favor rellene todos los campos", "error");
        return false;
      }
      if (this.checkEmail() == false && process.env.VUE_APP_USACH_MAIL == true) {
        this.showSnackbar("El email debe ser @usach.cl", "error");
        return false;
      }
      if (!this.verifyPassword()) {
        this.showSnackbar("Las contraseñas no coinciden", "error");
        return false;
      }
      if (!this.termsAccepted) {
        this.showSnackbar("Debe aceptar los términos y condiciones para registrarse", "error");
        return false;
      }
    },
    async userExists(email){
      try {
        const response = await axios.get(`/api/user/perfil/email/${email}`);
        const output = response.data ? true : false;
        console.log(output);
        return output;
      } catch (error) {
        console.error("Error checking user existence:", error);
        return false;
      }
    },
    async login() {
      // const idProject = this.$route.params.projectId;
      try {
        // Realizar login normal
        const response = await api.post(`/api/auth/signin`, {
          email: this.email,
          password: this.password,
        });

        // Si las credenciales son incorrectas
        if (!response.data.token) {
          return false;
        }

        const token = response.data.token;
        return token;
        
      } catch (error) {
        console.error(error);
        return false;
      }
    },
    async register() {
      if(!this.validateInputs()){
        return;
      }
      
      // Si el usuario existe
      if(this.userExists(this.email)){
        // Login para obtener el token
        const token = await this.login();
        if(!token){
          this.showSnackbar("Su usuario ya existe pero ingresó credenciales incorrectas", "error");
          return;
        }

        // Agregarlo al proyecto
        
      }

      try {
        await api.post(`/api/auth/signup`, {
          email: this.email,
          password: this.password,
          name: `${this.nombre} ${this.apellido}`,
          role: "user",
        });
        this.showSnackbar("Usuario registrado correctamente. Te llevaremos al login", "success");
        setTimeout(() => {
          // Destruir vanta.js
          if (this.vantaEffect){
            this.vantaEffect.destroy();
            this.vantaEffect = null;
          }
          this.$router.push("/login");
        }, 3000);
      } catch (error) {
        this.showSnackbar("Este usuario ya existe", "error");
      }
    },
    goToLogin() {
      this.$router.push("/login");
    },
    showSnackbar(message, type) {
      this.snackbarText = message;
      this.snackbarColor = type === "error" ? "red" : "green";
      this.snackbar = true;
    },
  },
  mounted() {
    if(this.$refs.vantaContainer) {
      this.vantaEffect = FOG({
        el: this.$refs.vantaContainer,
        THREE,
        mouseControls: false,
        touchControls: false,
        gyroControls: false,
        minHeight: 200.0,
        minWidth: 200.0,
        scale: 1.0,
        scaleMobile: 1.0,
        highlightColor: parseInt('0xffff', 16),
        midtoneColor: parseInt('8A4584', 16),
        lowlightColor: parseInt('0xd200ff', 16),
      });
      console.log("Vanta FOG initialized!");

    }
  },
  beforeUnmount() {
    if (this.vantaEffect) {
      this.vantaEffect.destroy();
      this.vantaEffect = null;
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.vantaEffect) {
      this.vantaEffect.destroy();
      this.vantaEffect = null;
    }
    next();
  },
};
</script>

<style scoped>
.register-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: rgba(255, 255, 255, 0.7);
}

.register-box {
  background-color: rgba(255, 255, 255, 0.7);
  padding: 30px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  text-align: center;
  width: 350px;
  z-index: 1;
}

.title-gradient {
  font-size: 24px;
  font-weight: bold;
  background: linear-gradient(90deg, #17a2b8, #ff9800);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.beta {
  font-weight: normal;
}

.register-form {
  display: flex;
  flex-direction: column;
  margin-top: 20px;
}

label {
  text-align: left;
  font-size: 14px;
  margin-bottom: 5px;
  color: #444;
}

.input-field {
  margin-bottom: 15px;
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 16px;
  width: 100%;
  background-color: #f9f9f9;
}

.checkbox-group {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}

.checkbox-group label {
  margin-left: 8px;
  font-size: 14px;
  color: #444;
}

.register-button,
.back-button {
  padding: 12px;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  width: 100%;
  margin-top: 10px;
}

.register-button {
  background-color: #20c997;
  color: white;
}

.register-button:hover {
  background-color: #17a2b8;
}

.back-button {
  background-color: white;
  color: #17a2b8;
  border: 2px solid #17a2b8;
}

.back-button:hover {
  background-color: #17a2b8;
  color: white;
}
</style>
